import { create } from "zustand";
import { axiosHelper, tokenHelper } from "./helpers";
import { filterNonFalseValues } from "./helpers/Utlis";

export const useOrderStore = create((set, get) => ({
  orders: [],
  isLoading: false,
  statsLoading: false,
  isError: false,
  error: undefined,
  orderStats: [],
  ordersPerDayReport: [],
  menuItemReport: null,
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createOrder: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/order/create", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh the list of orders
      await get().getOrders();
      return true;
    } catch (e) {
      console.error("Error creating order:", e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getOrders: async (filters = {}, page = 1, limit = 10) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      // const queryParams = new URLSearchParams({
      //   ...filterNonFalseValues(filters),
      //   page: page.toString(),
      //   limit: limit.toString(),
      // }).toString();

      // let response2 = await axiosHelper.get(
      //   `/order/report/general?${queryParams}`,
      //   {
      //     headers: { Authorization: `Bearer ${accessToken}` },
      //   }
      // );
      let response = await axiosHelper.post(
        `/v2/order/report/general`,
        filters,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({ orders: response, isLoading: false });
    } catch (e) {
      console.error("Error fetching orders:", e);
    } finally {
      set({ isLoading: false });
    }
  },
  getOrderStats: async (filters = {}) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ statsLoading: true });

      let response = await axiosHelper.post(`/v2/order/report/stats`, filters, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({ orderStats: response, isLoading: false });
    } catch (e) {
      console.error("Error fetching order stats:", e);
    } finally {
      set({ statsLoading: false });
    }
  },

  getOrdersPerDayReport: async (siteIds, startDate, endDate, timezone = "UTC") => {
    const siteIdsString = siteIds.join(",");

    try {
      const accessToken = await tokenHelper.getToken();
      set({ statsLoading: true });

      const params = new URLSearchParams();
      if (siteIds.length > 0) params.append("sites", siteIdsString);
      if (startDate) params.append("startDate", startDate.toISOString());
      if (endDate) params.append("endDate", endDate.toISOString());
      // Add timezone parameter
      if (timezone) params.append("timezone", timezone);

      const response = await axiosHelper.get(
        `/order/reporting/orders-per-day?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );



      set({
        ordersPerDayReport: response,
        statsLoading: false,
      });

      return response;
    } catch (e) {
      console.error("Failed to fetch orders per day report:", e);
      set({
        isError: true,
        error: e.message || "Failed to fetch orders per day report",
        statsLoading: false
      });
    } finally {
      set({ statsLoading: false });
    }
  },
  getMenuItemReport: async ({ menuItemId, startDate, endDate, timezone = "UTC", choiceId, kitchenIds = [], siteId }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ statsLoading: true, isError: false, error: undefined });

      const params = new URLSearchParams();
      params.append("menuItemId", String(menuItemId));
      if (startDate) params.append("startDate", startDate.toISOString());
      if (endDate) params.append("endDate", endDate.toISOString());
      if (timezone) params.append("timezone", timezone);
      if (choiceId) params.append("choiceId", String(choiceId));
      if (kitchenIds.length > 0) params.append("kitchenIds", kitchenIds.join(","));
      if (siteId) params.append("siteId", String(siteId));

      const response = await axiosHelper.get(
        `/order/reporting/menu-item?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({ menuItemReport: response, statsLoading: false });
      return response;
    } catch (e) {
      console.error("Failed to fetch menu item report:", e);
      set({
        isError: true,
        error: e?.response?.data?.message || e.message || "Failed to fetch menu item report",
        statsLoading: false,
      });
      return null;
    }
  },
  updateOrder: async (id, info) => {
    try {
      const accessToken = await tokenHelper.getToken();

      set({ isLoading: true });
      let response = await axiosHelper.patch(`/order/${id}`, info, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // 
      get().getOrders();
    } catch (e) {
      console.error("Error updating order:", e);
    } finally {
      set({ isLoading: false });
    }
  },
  deleteOrder: async (menuId) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.delete(`/menu/${menuId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // 
      get().getOrders();
    } catch (e) {
      console.error("Error deleting order:", e);
    } finally {
      set({ isLoading: false });
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
}));
